export default __webpack_public_path__ + "static/media/granville05.578a4361.jpg";